import Api from '../Api';

import { url } from './config';
import { PaymentTermsOption } from './types';

const api = new Api<PaymentTermsOption>(url);

export default api;
